'use client'

import VLibras from '@djpfs/react-vlibras'

export function VLibrasClient() {
  return <VLibras />
}
